import { AppAction, AsyncActionType, BaseAsyncReducerState } from "./types";

export default function defaultAsyncReducerWithReset(state: BaseAsyncReducerState, action: AppAction, actionType: AsyncActionType, resetAction: string, initialState: BaseAsyncReducerState) {
  const { payload } = action;

  switch (action.type) {
    case actionType.PENDING:
      return {
        ...state,
        loading: true,
        success: false,
        error: false,
      }
    case actionType.SUCCESS:
      return {
        ...state,
        ...payload,
        loading: false,
        success: true,
        error: false,
      }
    case actionType.ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: payload
      };
    case resetAction:
      return initialState;
    default:
      return state
  }
}